import React, {PropsWithChildren, useCallback, useState} from 'react';
import {AlertColor} from '@mui/material';

import AppSnackbar from '@/components/ui/snackbar';

import SnackbarContext from './context';

type Props = PropsWithChildren;
export const SnackbarProvider: React.FC<Props> = ({
  children
}): React.ReactElement => {
  const [visible, setVisible] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [severity, setSeverity] = useState<AlertColor>('error');
  const [duration, setDuration] = useState<number | undefined>(undefined);

  const showSnackbarMessage = useCallback(
    (message: string, severity: AlertColor, duration = 6000) => {
      setMessage(message);
      setSeverity(severity);
      setVisible(true);
      setDuration(duration);
    },
    []
  );

  const onClose = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <SnackbarContext.Provider value={{showSnackbarMessage}}>
      {children}
      <AppSnackbar
        message={message}
        severity={severity}
        open={visible}
        onClose={onClose}
        duration={duration}
      />
    </SnackbarContext.Provider>
  );
};
export default SnackbarProvider;
